import { Box, LinearProgress, Stack, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'

import { useController } from '../hooks/useController'
import { useRotatingText } from '../hooks/useRotatingText'
import { OptimizationConfigPanel } from './OptimizationConfigPanel'
import { RouteAnimation } from './RouteAnimation'

export function Step2() {
  const {
    data: { progress },
  } = useController()
  const rotatingText = useRotatingText(progress)

  // progressbar_percentage = (progress - 50) * 2, clamped to [0, 100]
  const pct = typeof progress === 'number' ? Math.max(0, Math.min(100, (progress - 50) * 2)) : 100

  return (
    <Stack alignItems="center" sx={{ pt: '14px', pb: '15px' }}>
      <Box sx={{ mb: '24px' }}>
        <RouteAnimation size={64} />
      </Box>

      <Typography variant="subtitle1" sx={{ mb: '8px', fontSize: 16, fontWeight: 400 }}>
        <FormattedMessage
          id="modals.buildProgress.step2.title"
          values={{
            b: chunks => (
              <Box component="span" sx={{ fontWeight: 500 }}>
                {chunks}
              </Box>
            ),
          }}
        />
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mb: '32px', minHeight: 20 }}>
        {rotatingText}
      </Typography>

      <Stack direction="row" alignItems="center" spacing={1.5} sx={{ width: '100%', mb: '32px' }}>
        <Box flex={1}>
          <LinearProgress variant="determinate" value={pct} sx={{ height: 8, borderRadius: 1 }} />
        </Box>
        <Typography variant="caption" sx={{ minWidth: 36, textAlign: 'right' }}>
          {Math.round(pct)}%
        </Typography>
      </Stack>

      <Box sx={{ width: '100%' }}>
        <OptimizationConfigPanel />
      </Box>
    </Stack>
  )
}
